/**
 * /tenants/$slug/security/frontline/kiosk-pass — the Kiosk Pass
 * offering page. Same prefetch set as Badge Sign-In (config gates
 * the page; stations + groups are the warm config surfaces shown once
 * Kiosk Pass is on). Prefetch failures don't block the route.
 */

import { createFileRoute } from "@tanstack/react-router";
import {
  fetchFrontlineConfig,
  fetchFrontlineGroups,
  fetchStations,
} from "@/features/frontline/queries";
import { KioskPassPage } from "@/features/frontline/pages/frontline-page";

export const Route = createFileRoute(
  "/_authed/tenants/$slug/security/frontline/kiosk-pass",
)({
  loader: async ({ context }) => {
    const id = context.tenant.id;
    await Promise.allSettled([
      context.queryClient.ensureQueryData({
        queryKey: ["admin", "frontline", id, "config"],
        queryFn: () => fetchFrontlineConfig(id),
      }),
      context.queryClient.ensureQueryData({
        queryKey: ["admin", "frontline", id, "stations"],
        queryFn: () => fetchStations(id),
      }),
      context.queryClient.ensureQueryData({
        queryKey: ["admin", "frontline", id, "groups"],
        queryFn: () => fetchFrontlineGroups(id),
      }),
    ]);
  },
  component: KioskPassPage,
});
